import Synchronization from './Synchronization'
import withState from './withState'

export default withState(Synchronization)
